import FastMarquee from "react-fast-marquee";
import { Diamond } from "./shared";
import { useLang } from "@/i18n";

export default function Marquee() {
  const { t } = useLang();
  const items = t("marquee");
  return (
    <div className="border-y border-olive/20 bg-sand py-5" data-testid="editorial-marquee">
      <FastMarquee speed={30} gradient={false}>
        {items.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8 text-xs font-semibold uppercase tracking-[0.3em] text-olive">
            {item}
            <Diamond />
          </span>
        ))}
      </FastMarquee>
    </div>
  );
}
